// extracted by css-extract-rspack-plugin
export default {"header":"JEsWcDmYbhYfXLLu","title":"gKW8L_LFKVwO3b7u","divider":"Wcf4tH1fGyM_SEGG"};